import React from 'react';

import { cn } from 'lib/helpers/utility';

const ErrorMessage = ({ className, children, ...props }) => (
  <div
    {...props}
    role="status"
    aria-live="polite"
    aria-atomic="true"
    className={cn('error-message text-xs text-danger-500 first-letter:uppercase', className)}>
    {children}
  </div>
);
export default ErrorMessage;
